import { render, staticRenderFns } from "./AnalysisCopy.vue?vue&type=template&id=0dcaf836&scoped=true"
import script from "./AnalysisCopy.vue?vue&type=script&lang=js"
export * from "./AnalysisCopy.vue?vue&type=script&lang=js"
import style0 from "./AnalysisCopy.vue?vue&type=style&index=0&id=0dcaf836&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcaf836",
  null
  
)

export default component.exports